import { ActionType } from 'typesafe-actions'
import {
  ManagePlayerModalState,
  Player,
  Sorting,
  Watchlist,
  WatchlistSortingKeys,
} from 'types/global'
import Storage from 'modules/storage'
import {
  WATCHLIST_PLAYERS_REQUESTED,
  WATCHLIST_PLAYERS_COMPLETED,
  WATCHLIST_PLAYERS_FAILED,
  FETCH_WATCHLISTS_REQUESTED,
  FETCH_WATCHLISTS_COMPLETED,
  FETCH_WATCHLISTS_FAILED,
  UPDATE_WATCHLIST_REQUESTED,
  UPDATE_WATCHLIST_COMPLETED,
  UPDATE_WATCHLIST_FAILED,
  ADD_WATCHLIST_REQUESTED,
  ADD_WATCHLIST_COMPLETED,
  ADD_WATCHLIST_FAILED,
  REMOVE_WATCHLIST_REQUESTED,
  REMOVE_WATCHLIST_COMPLETED,
  REMOVE_WATCHLIST_FAILED,
  RESET_WATCHLIST_PLAYERS,
  SET_SORTING,
  SET_MANAGE_MODAL_STATE,
  SET_DESTINATION_WATCHLIST_IDS,
  ADD_DESTINATION_WATCHLIST_IDS,
  MANAGE_PLAYER_STARTED,
  MANAGE_PLAYER_COMPLETED,
} from 'actions/watchlist-actions'

import * as actions from 'actions/watchlist-actions'
import { AddOrManagePlayerModalMode } from 'constants/modals'
import { DEFAULT_TABLE_SORTING } from 'constants/player-search'
type WatchlistAction = ActionType<typeof actions>

export type State = Readonly<{
  destinationWatchlistIds: string[]
  watchlists: { [key: string]: Watchlist }
  watchlistPlayers: { [key: string]: Player[] }
  resolvingPlayers: boolean
  loadingWatchlists: boolean
  updatingWatchlist: boolean
  updatingPlayers: boolean
  sorting: { [key in WatchlistSortingKeys]: Sorting }
  playerIdsStore: { [key: string]: string[] }
  manageModal: ManagePlayerModalState
  manageOperations: Record<string, boolean>
}>

export const initialState: State = {
  destinationWatchlistIds: [],
  watchlistPlayers: {},
  resolvingPlayers: false,
  loadingWatchlists: false,
  updatingWatchlist: false,
  updatingPlayers: false,
  watchlists: {},
  sorting: {
    players: DEFAULT_TABLE_SORTING,
  },
  playerIdsStore: {},
  manageModal: {
    isOpen: false,
    mode: AddOrManagePlayerModalMode.MANAGE,
    includedWatchlistsIds: [],
  },
  manageOperations: {},
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: WatchlistAction): State {
  switch (action.type) {
    case FETCH_WATCHLISTS_REQUESTED:
      return { ...state, loadingWatchlists: true }
    case FETCH_WATCHLISTS_COMPLETED:
      const { watchlistsById, playerIdsStore } = transformWatchlistsForStore(action.payload)
      return {
        ...state,
        watchlists: watchlistsById,
        playerIdsStore,
        loadingWatchlists: false,
      }
    case FETCH_WATCHLISTS_FAILED:
      return { ...state, loadingWatchlists: false }
    case WATCHLIST_PLAYERS_REQUESTED:
      return { ...state, resolvingPlayers: true }
    case WATCHLIST_PLAYERS_COMPLETED:
      return {
        ...state,
        resolvingPlayers: false,
        watchlistPlayers: {
          ...state.watchlistPlayers,
          [action.payload.id]: action.payload.players,
        },
      }
    case WATCHLIST_PLAYERS_FAILED:
      return { ...state, resolvingPlayers: false }
    case RESET_WATCHLIST_PLAYERS:
      return {
        ...state,
        watchlistPlayers: {
          ...state.watchlistPlayers,
          [action.payload.watchlistId]: [],
        },
      }
    case UPDATE_WATCHLIST_REQUESTED:
      return { ...state, updatingWatchlist: true }
    case UPDATE_WATCHLIST_COMPLETED:
      return {
        ...state,
        updatingWatchlist: false,
        watchlists: { ...state.watchlists, [action.payload.id]: action.payload },
      }
    case UPDATE_WATCHLIST_FAILED:
      return { ...state, updatingWatchlist: false }
    case ADD_WATCHLIST_REQUESTED:
      return { ...state, loadingWatchlists: true }
    case ADD_WATCHLIST_COMPLETED:
      return {
        ...state,
        loadingWatchlists: false,
        watchlists: { ...state.watchlists, [action.payload.id]: action.payload },
      }
    case ADD_WATCHLIST_FAILED:
      return { ...state, loadingWatchlists: false }
    case REMOVE_WATCHLIST_REQUESTED:
      return { ...state, loadingWatchlists: true }
    case REMOVE_WATCHLIST_COMPLETED:
      delete state.watchlists[action.payload]
      return {
        ...state,
        loadingWatchlists: false,
        watchlists: { ...state.watchlists },
      }
    case REMOVE_WATCHLIST_FAILED:
      return { ...state, loadingWatchlists: false }
    case SET_SORTING:
      return {
        ...state,
        sorting: {
          ...state.sorting,
          [action.payload.watchlistSortingId]: action.payload.sorting,
        },
      }
    case SET_MANAGE_MODAL_STATE:
      return {
        ...state,
        manageModal: {
          ...state.manageModal,
          ...action.payload,
        },
      }
    case SET_DESTINATION_WATCHLIST_IDS:
      Storage.saveDestinationWatchlistIds(action.payload)
      return {
        ...state,
        destinationWatchlistIds: action.payload,
      }
    case ADD_DESTINATION_WATCHLIST_IDS:
      const destinationWatchlistIds = [...state.destinationWatchlistIds, ...action.payload]
      Storage.saveDestinationWatchlistIds(destinationWatchlistIds)
      return {
        ...state,
        destinationWatchlistIds,
      }
    case MANAGE_PLAYER_STARTED:
      return {
        ...state,
        manageOperations: { ...state.manageOperations, [action.payload]: true },
      }
    case MANAGE_PLAYER_COMPLETED:
      delete state.manageOperations[action.payload]
      state = {
        ...state,
        manageOperations: { ...state.manageOperations },
      }
      if (state.manageModal.isOpen && state.manageModal.player?.id === action.payload)
        state = { ...state, manageModal: { ...state.manageModal, isOpen: false } }
      return state
    default:
      return state
  }
}

export const transformWatchlistsForStore = (watchlists: Watchlist[]) => {
  const watchlistsById = {}
  const playerIdsStore = {}
  watchlists.forEach(wl => {
    watchlistsById[wl.id] = wl
    wl.playerIds.forEach(playerId => {
      if (playerIdsStore[playerId]) {
        playerIdsStore[playerId].push(wl.id)
      } else {
        playerIdsStore[playerId] = [wl.id]
      }
    })
  })
  return { watchlistsById, playerIdsStore }
}
